module.exports = __webpack_public_path__ + "static/media/Announcementsboy.80e02e71.png";